module.exports = __webpack_public_path__ + "static/img/emotion.00f9596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emotion.png
// module id = MODb
// module chunks = 1